import React from 'react';

import {
  Modal,
} from '@salesforce/design-system-react';

function useToggle(initialValue = false) {
  const [value, setValue] = React.useState(initialValue);
  const toggle = React.useCallback(() => {
    setValue((v) => !v);
  }, []);
  return [value, toggle];
}

const ConnectorInstructions = () => {
  const [isOpen, toggleIsOpen] = useToggle();

  return (
    <React.Fragment>
      <div 
        style={{ fontSize: '.8rem'}}>
          What are <span style={{ color: '#1B96FF', fontWeight: '600', cursor: 'pointer'}} onClick={toggleIsOpen}>Connectors?</span>
      </div>
      <Modal
        isOpen={isOpen}
        onRequestClose={toggleIsOpen}
        heading="What are Milestones Connectors?"
      >
        <div
          style={{
            marginTop: '5px',
            marginBottom: '5px',
          }}
          className="slds-text-body_large slds-p-around_medium"
        >
            <div
              style={{ marginTop: '5px', marginBottom: '5px' }}
              className="slds-text-body_large"
            >
              Now that we've defined all of your milestones, we can start to
              fill in all of the events that connect each of those milestones
              together. Consider the products and solutions that you are
              positioning for your customer - the connecting events should be
              leading us down the path that showcases these products and
              solutions. Remember, we are in the future state after your
              customer has implemented all of this incredible Salesforce
              functionality and we want to showcase the value added for each
              persona along the way.
            </div>
            <div
              style={{ marginTop: '5px', marginBottom: '5px' }}
              className="slds-text-body_large"
            >
              The tool below works similarly to the last tool, but each card
              gets added between our milestones to shape our story. It's easiest
              to think of these events chronologically and enter them in as you
              go. Use the title to capture the primary story element and then
              feel free to capture additional discussion or details with the
              content.
            </div>
        </div>
      </Modal>
    </React.Fragment>
  );
};

export default ConnectorInstructions;
